import { useState } from "react";
import DatasetsPage from "./DatasetsPage";
import DataRealityPage from "./DataRealityPage";
import AuditPage from "./AuditPage";

const SECTIONS = [
  { id: "sources", label: "Data sources", Page: DatasetsPage },
  { id: "reality", label: "Data reality", Page: DataRealityPage },
  { id: "audit", label: "Query audit", Page: AuditPage },
];

/** Provenance in one place: what we hold, what we cannot compute, and every answer given. */
export default function DataTrustPage() {
  const initial = new URLSearchParams(window.location.search).get("section") || "sources";
  const [section, setSection] = useState(SECTIONS.some((s) => s.id === initial) ? initial : "sources");
  const { Page } = SECTIONS.find((s) => s.id === section);

  return (
    <div data-testid="data-trust-page">
      <div className="inline-flex border border-stone-200 rounded-xl bg-white p-1 mb-8" data-testid="data-trust-sections">
        {SECTIONS.map((s) => (
          <button
            key={s.id}
            onClick={() => setSection(s.id)}
            data-testid={`data-trust-section-${s.id}`}
            className={`px-4 py-2 rounded-lg text-[13px] font-medium transition-colors ${
              section === s.id ? "bg-stone-900 text-white" : "text-stone-600 hover:bg-stone-100"
            }`}
          >
            {s.label}
          </button>
        ))}
      </div>
      <Page key={section} />
    </div>
  );
}
